export default "__VITE_ASSET__DAEqoLg$__"